<!--
Should the server return 503 responses while the App is already loaded,
then show this component.
-->

<template>
  <v-layout
    column
    justify-center
    align-center
    fill-height
  >
    <div class="mt-5 grow-0">
      <!-- Note: Don't use our static host here -->
      <img src="https://img.icons8.com/dusk/144/000000/maintenance.png">
    </div>
    <v-layout
      column
      align-center
      class="mt-2 text-xs-center grey--text text--darken-1"
    >
      <div class="headline">
        {{ $t('maintenanceHeadline') }}
      </div>
      <div class="mt-2 subheading">
        {{ $t('maintenanceSubheader') }}
      </div>
      <v-btn
        class="mt-5"
        :loading="busy"
        :title="$t('reloadPage')"
        @click="pingAPI()"
      >
        <v-icon>refresh</v-icon>
      </v-btn>
    </v-layout>
  </v-layout>
</template>

<script>
export default {
  name: 'Maintenance',
  data() {
    return {
      busy: false,
    };
  },
  mounted() {
    this.$store.commit('RESET_ENTIRE_STATE');
  },
  methods: {
    pingAPI() {
      this.busy = true;
      const tokenAuth = false;
      // We simply ping the /api/v1 root endpoint.
      this.$api
        .request('get', '', null, null, tokenAuth)
        .then((response) => {
          this.busy = false;
          this.$router.push('/dashboard');
        })
        .catch((error) => {
          console.error('ping failed:', error.response);
          let type = 'error';
          if (error.response.status === 503) {
            type = 'info';
          }
          this.busy = false;
          const message =
            this.$t('maintenanceHeadline') +
            '. ' +
            this.$t('maintenanceSubheader') +
            '.';
          this.$bus.$emit('alert-' + type, {
            message: message,
            translate: false,
          });
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Maintenance.vue